import { GridItem as ChakraGridItem, GridItemProps as ChakraGridItemProps } from '@chakra-ui/react';
import React from 'react';

export function GridItem(props: ChakraGridItemProps) {
  return <ChakraGridItem {...props} />;
}
